import { useTranslation } from '@/i18n';
import { Label } from '@moneyforward/ap-frontend-components';
import { SearchedApPayee } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, useMemo } from 'react';
import { usePreviewContent } from '../Hooks/usePreviewContent';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface PreviewInstructionProps {
  currentPreviewPayee?: SearchedApPayee;
  height: number;
}

export const PreviewInstruction: FC<PreviewInstructionProps> = ({
  currentPreviewPayee,
  height,
}) => {
  const { t } = useTranslation();
  const { previewContent } = usePreviewContent(currentPreviewPayee?.id ?? '');

  // Memoize style object to prevent recreation on every render
  const contentStyle = useMemo(() => ({ height: `${height}px` }), [height]);

  return (
    <div className={cx('preview-instruction')}>
      <div className={styles.row}>
        <div className={styles.label}>
          <Label text={t('send_instruction_email_subject')} htmlFor='content' />
        </div>
        <div className={cx('viewer')}>{previewContent.subject}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.label}>
          <Label text={t('export_instruction_pdf_content')} htmlFor='content' />
        </div>
        <div className={cx('viewer-content')} style={contentStyle}>
          {previewContent.content}
        </div>
      </div>
    </div>
  );
};

PreviewInstruction.displayName = 'PreviewInstruction';
